module.exports = __webpack_public_path__ + "static/media/pkg-f3-basic_sq_1.2574d8a9.png";